// Real Sunsari Restaurant Menu Data
// Weekly lunch buffet – Premium Edition

export const lunchMenu = {
  title: "Sunsari Weekly Lunch Buffet",
  subtitle: "Premium Edition",
  description: "Fresh and delicious meals served Monday to Saturday",
  welcomeMessage: "Tervetuloa nauttimaan runsasta ja maukasta lounasta! Lounaaseen sisältyy aina monipuolinen raikas salaattipöytä, tuoretta naan-leipää, riisiä, intialaista teetä (masala chai) sekä päivän jälkiruoka.",
  festivalOffer: {
    active: false
  },
  priceInfo: {
    regular: "14,00€",
    pensioner: "13,00€",
    student: "13,50€",
    weekend: {
      regular: "18,50€",
      pensioner: "17,50€",
      student: "18,00€"
    }
  },
  everyday: [
    { name: "Handmade Tandoori Naan Bread" },
    { name: "Basmati Rice", dietary: ["L", "G", "V"] },
    { name: "17+ käsintehtyä salaattia — isosta salaattipöydästä, tuoreena joka aamu" },
    { name: "Cucumber Carrot Raita", dietary: ["G"] },
    { name: "Traditional Nepalese Chai — Masala Milk Tea", dietary: ["G"] },
    { name: "Mango Lassi", dietary: ["G"] }
  ],
  saladHighlight: {
    title: "17+ käsintehtyä salaattia",
    subtitle: "Tuoreena joka aamu · iso salaattipöytä",
    titleSv: "17+ handgjorda sallader",
    subtitleSv: "Färska varje morgon · stort salladsbord",
    descriptionSv: "Vårt stora salladsbord är buffén hjärta — över 17 handgjorda sallader, dippar och fräscha tillbehör som tillreds färska varje morgon.",
    titleEn: "17+ handmade salads",
    subtitleEn: "Freshly made every morning · big salad table",
    descriptionEn: "Our big salad table is the heart of the buffet — more than 17 handmade salads, dips and fresh sides prepared every morning.",
    description: "Iso salaattipöytämme on buffeen sydän — yli 17 käsintehtyä, tuoreena joka aamu valmistettua salaattia, dippiä ja raikasta lisuketta jokaiselle makuun."
  },
  warmDishesIntro: {
    fi: "Lämpimät ruoat valmistetaan käsin joka päivä: pehmeitä curryja, tandoori-uunissa grillattuja herkkuja, höyryssä kypsytettyä riisiä ja tuoretta naan-leipää. Jokainen kastike ja marinadi on tehty alusta asti meidän keittiössämme.",
    en: "Our warm dishes are made from scratch every day — slow-simmered curries, tandoor-grilled specialties, steamed basmati rice and fresh naan. Every sauce and marinade is prepared in-house with hand-ground spices."
  },
  dailyMenus: {
    monday: {
      day: "Monday · Himalayan Comfort Food",
      daySv: "Måndag · Himalayansk comfort food",
      dayFi: "Maanantai · Himalajan kotiruoka",
      hours: "11:00-15:00",
      mains: [
        { name: "Royal Butter Chicken", nameSv: "Kunglig smörkyckling", nameFi: "Kuninkaallinen voikana", descriptionFi: "Mureaa kanaa täyteläisessä, kermaisessa ja miedosti maustetussa voikastikkeessa. Kokin suosikki.", chefPick: true, description: "Tender chicken in a rich, creamy and mildly spiced butter sauce. Chef-recommended favourite.", descriptionSv: "Mör kyckling i en fyllig, krämig och milt kryddad buttersås. En favorit som kocken rekommenderar.", dietary: ["L", "G"] },
        { name: "Himalayan Garlic-Grilled Chicken", nameSv: "Himalayansk vitlöksgrillad kyckling", nameFi: "Himalajan valkosipuligrillikana", descriptionFi: "Grillattua kanaa tuoreella valkosipulilla, inkiväärillä ja aromaattisilla yrteillä.", description: "Grilled chicken infused with fresh garlic, ginger and aromatic herbs.", descriptionSv: "Grillad kyckling smaksatt med färsk vitlök, ingefära och aromatiska örter.", dietary: ["L", "G"] },
        { name: "Slow-Cooked Himalayan Pork Curry", nameSv: "Långkokt himalayansk fläskcurry", nameFi: "Haudutettu Himalajan porsascurry", descriptionFi: "Mureaa porsasta hitaasti haudutettuna maukkaassa Himalajan maustecurryssa.", description: "Tender pork simmered slowly in a flavourful Himalayan spice curry.", descriptionSv: "Mört fläsk som fått sjuda länge i en smakrik himalayansk kryddcurry.", dietary: ["L", "G"] },
        { name: "Golden Aloo Gobi", nameSv: "Gyllene aloo gobi", nameFi: "Kultainen aloo gobi", descriptionFi: "Perunaa ja kukkakaalia lämmittävien mausteiden kera.", description: "Potatoes and cauliflower cooked with warming spices.", descriptionSv: "Potatis och blomkål tillagade med värmande kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Creamy Spinach Tofu", nameSv: "Krämig spenat-tofu", nameFi: "Kermainen pinaattitofu", descriptionFi: "Pehmeää tofua kermaisessa, maukkaassa pinaattikastikkeessa.", description: "Soft tofu in a creamy, flavourful spinach sauce.", descriptionSv: "Mjuk tofu i en krämig och smakrik spenatsås.", dietary: ["L", "G"] },
        { name: "Himalayan Crispy Vegetable Pakora", nameSv: "Himalayansk krispig grönsaks-pakora", nameFi: "Himalajan rapeat kasvispakorat", descriptionFi: "Rapeita kasvisfrittereitä maustetussa kikhernejauhokuoressa.", description: "Crisp vegetable fritters coated in seasoned gram flour.", descriptionSv: "Krispiga grönsaksfritters panerade i kryddat kikärtsmjöl.", dietary: ["L", "G", "V"], vegan: true }
      ],
      sides: [
        { name: "Basmati Rice", nameSv: "Basmatiris", nameFi: "Basmatiriisi", dietary: ["L", "G", "V"] },
        { name: "Nepalese-Style Pulao Rice", nameSv: "Pulao-ris på nepalesiskt vis", nameFi: "Nepalilainen pulao-riisi", dietary: ["G"] },
        { name: "Fresh Tandoori Naan Bread", nameSv: "Färskt tandoori-naanbröd", nameFi: "Tuore tandoori-naanleipä" },
        { name: "Raita", nameSv: "Raita", nameFi: "Raita (jogurttikastike)", dietary: ["G"] },
        { name: "Mango Lassi", nameSv: "Mango lassi", nameFi: "Mango lassi", dietary: ["G"] },
        { name: "Traditional Nepalese Chai — Masala Milk Tea", nameSv: "Traditionell nepalesisk chai — masala mjölkte", nameFi: "Perinteinen nepalilainen chai – maustettu maitotee", dietary: ["G"] }
      ],
      desserts: [
        { name: "Dessert of the Day — Specially Handmade with Love", nameSv: "Dagens dessert — handgjord med kärlek", nameFi: "Päivän jälkiruoka – käsin tehty rakkaudella", descriptionFi: "Nauti erityisestä, tuoreena valmistetusta kotitekoisesta jälkiruoasta, jonka keittiömme on tehnyt rakkaudella – buffet-kokemuksesi makea päätös. Ravintola Sunsari – ripaus makeutta, alusta asti itse tehty.", description: "Enjoy a special, freshly prepared homemade dessert, lovingly crafted by our kitchen to make your buffet experience even sweeter. Ravintola Sunsari — A little sweetness, made from scratch.", descriptionSv: "Njut av en särskild, nygjord hemlagad dessert, omsorgsfullt tillagad av vårt kök för att göra din bufféupplevelse ännu sötare. Restaurang Sunsari — lite sötma, lagad från grunden." }
      ]
    },
    tuesday: {
      day: "Tuesday · Nepalese Street Food",
      daySv: "Tisdag · Nepalesisk street food",
      dayFi: "Tiistai · Nepalilainen katuruoka",
      hours: "11:00-15:00",
      mains: [
        { name: "Royal Butter Chicken", nameSv: "Kunglig smörkyckling", nameFi: "Kuninkaallinen voikana", descriptionFi: "Mureaa kanaa tunnusomaisessa, kermaisessa voikastikkeessamme.", chefPick: true, description: "Tender chicken in our signature creamy butter sauce.", descriptionSv: "Mör kyckling i vår signatur-krämiga buttersås.", dietary: ["L", "G"] },
        { name: "Smoky Himalayan Chicken Choila with Tomato Achar", nameSv: "Rökig himalayansk kyckling choila med tomat-achar", nameFi: "Savuinen Himalajan kana-choila ja tomaattiachar", descriptionFi: "Savuista, maustettua grillikanaa kirpeän nepalilaisen tomaattipikkelsin kera.", description: "Smoky, spiced grilled chicken served with tangy Nepalese tomato pickle.", descriptionSv: "Rökig, kryddad grillad kyckling serverad med syrlig nepalesisk tomatpickles.", dietary: ["L", "G"] },
        { name: "Nepalese Pork Choila with Crispy Onions", nameSv: "Nepalesisk fläsk choila med krispig lök", nameFi: "Nepalilainen porsas-choila ja rapea sipuli", descriptionFi: "Perinteisesti maustettua, savuista porsasta rapean sipulin kera.", description: "Traditional spiced pork with smoky flavours and crispy onions.", descriptionSv: "Traditionellt kryddat fläsk med rökiga smaker och krispig lök.", dietary: ["L", "G"] },
        { name: "Royal Creamy Malai Kofta", nameSv: "Kunglig krämig malai kofta", nameFi: "Kuninkaallinen kermainen malai kofta", descriptionFi: "Pehmeitä kasvispyöryköitä täyteläisessä, kermaisessa kastikkeessa.", description: "Soft vegetable dumplings in a rich, creamy sauce.", descriptionSv: "Mjuka grönsaksdumplings i en fyllig, krämig sås.", dietary: ["G"] },
        { name: "Spicy Tofu Chilli", nameSv: "Stark tofu chilli", nameFi: "Tulinen chilitofu", descriptionFi: "Tofua chilin, valkosipulin ja voimakkaiden mausteiden kera.", description: "Tofu tossed with chilli, garlic and bold spices.", descriptionSv: "Tofu vänd i chilli, vitlök och kraftiga kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Crispy Vegetable Pakora", nameSv: "Krispig grönsaks-pakora", nameFi: "Rapeat kasvispakorat", descriptionFi: "Kullanruskeita kasvisfrittereitä kevyesti maustetussa, rapeassa kuoressa.", description: "Golden vegetable fritters with a lightly spiced, crispy coating.", descriptionSv: "Gyllenbruna grönsaksfritters med ett lätt kryddat, krispigt yttre.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Mustard-Spiced Potatoes", nameSv: "Potatis med senapskryddor", nameFi: "Sinappimaustetut perunat", descriptionFi: "Perunaa sinapinsiementen ja aromaattisten mausteiden kera.", description: "Potatoes seasoned with mustard seeds and aromatic spices.", descriptionSv: "Potatis kryddad med senapsfrön och aromatiska kryddor.", dietary: ["L", "G", "V"], vegan: true }
      ],
      sides: [
        { name: "Basmati Rice", nameSv: "Basmatiris", nameFi: "Basmatiriisi", dietary: ["L", "G", "V"] },
        { name: "Nepalese-Style Pulao Rice", nameSv: "Pulao-ris på nepalesiskt vis", nameFi: "Nepalilainen pulao-riisi", dietary: ["G"] },
        { name: "Fresh Tandoori Naan Bread", nameSv: "Färskt tandoori-naanbröd", nameFi: "Tuore tandoori-naanleipä" },
        { name: "Raita", nameSv: "Raita", nameFi: "Raita (jogurttikastike)", dietary: ["G"] },
        { name: "Mango Lassi", nameSv: "Mango Lassi", nameFi: "Mango lassi", dietary: ["G"] },
        { name: "Traditional Nepalese Chai — Masala Milk Tea", nameSv: "Traditionell nepalesisk chai — Masala-mjölkte", nameFi: "Perinteinen nepalilainen chai – maustettu maitotee", dietary: ["G"] }
      ],
      desserts: [
        { name: "Dessert of the Day — Specially Handmade with Love", nameSv: "Dagens dessert — handgjord med kärlek", nameFi: "Päivän jälkiruoka – käsin tehty rakkaudella", descriptionFi: "Nauti erityisestä, tuoreena valmistetusta kotitekoisesta jälkiruoasta, jonka keittiömme on tehnyt rakkaudella – buffet-kokemuksesi makea päätös. Ravintola Sunsari – ripaus makeutta, alusta asti itse tehty.", description: "Enjoy a special, freshly prepared homemade dessert, lovingly crafted by our kitchen to make your buffet experience even sweeter. Ravintola Sunsari — A little sweetness, made from scratch.", descriptionSv: "Njut av en speciell, nylagad hemlagad dessert, omsorgsfullt tillagad av vårt kök för att göra din bufféupplevelse ännu sötare. Restaurang Sunsari — lite sötma, gjord från grunden." }
      ]
    },
    wednesday: {
      day: "Wednesday · Tandoori Grill Festival",
      daySv: "Onsdag · Tandoorigrillfestival",
      dayFi: "Keskiviikko · Tandoori-grillifestivaali",
      hours: "11:00-15:00",
      mains: [
        { name: "Royal Butter Chicken", nameSv: "Kunglig smörkyckling", nameFi: "Kuninkaallinen voikana", descriptionFi: "Mureaa kanaa haudutettuna täyteläisessä, miedosti maustetussa voikastikkeessa.", chefPick: true, description: "Tender chicken simmered in a rich, mildly spiced butter sauce.", descriptionSv: "Mör kyckling som sjudits i en fyllig buttersås med mild kryddning.", dietary: ["L", "G"] },
        { name: "Tandoori Chicken Tikka Masala", nameSv: "Tandoorikyckling tikka masala", nameFi: "Tandoori-kana tikka masala", descriptionFi: "Tandoorissa grillattua kanaa maukkaassa tomaattipohjaisessa masalakastikkeessa.", description: "Tandoori-grilled chicken in a flavourful tomato-based masala sauce.", descriptionSv: "Tandoorigrillad kyckling i en smakrik tomatbaserad masala-sås.", dietary: ["L", "G"] },
        { name: "Smoky BBQ Pork with Caramelised Onions", nameSv: "Rökig BBQ-fläsk med karamelliserad lök", nameFi: "Savuinen BBQ-porsas ja karamellisoitu sipuli", descriptionFi: "Grillattua porsasta savuisella glaseerauksella ja makealla karamellisoidulla sipulilla.", description: "Barbecued pork with a smoky glaze and sweet caramelised onions.", descriptionSv: "Grillat fläsk med rökig glaze och söt karamelliserad lök.", dietary: ["L", "G"] },
        { name: "Royal Creamy Vegetable Korma", nameSv: "Kunglig krämig grönsakskorma", nameFi: "Kuninkaallinen kermainen kasviskorma", descriptionFi: "Sekakasviksia hienovaraisesti maustetussa, kermaisessa kastikkeessa.", description: "Mixed vegetables cooked in a delicately spiced, creamy sauce.", descriptionSv: "Blandade grönsaker tillagade i en milt kryddad, krämig sås.", dietary: ["L", "G"] },
        { name: "Himalayan Saag Kofta", nameSv: "Himalayansk saag kofta", nameFi: "Himalajan saag kofta", descriptionFi: "Kasvispyöryköitä maukkaassa pinaattipohjaisessa kastikkeessa.", description: "Vegetable dumplings served in a flavourful spinach-based sauce.", descriptionSv: "Grönsaksdumplings serverade i en smakrik spenatbaserad sås.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Golden Aloo Chops", nameSv: "Gyllene aloo chops", nameFi: "Kultaiset aloo chopit", descriptionFi: "Maustettuja perunapihvejä kullanruskealla, rapealla pinnalla.", description: "Seasoned potato patties with a golden, crispy exterior.", descriptionSv: "Kryddade potatisbiffar med gyllene, krispig yta.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Vegetable Pakora", nameSv: "Grönsakspakora", nameFi: "Kasvispakorat", descriptionFi: "Rapeita, maustettuja kasvisfrittereitä.", description: "Crunchy, spiced vegetable fritters.", descriptionSv: "Krispiga, kryddade grönsaksfritters.", dietary: ["L", "G", "V"], vegan: true }
      ],
      sides: [
        { name: "Basmati Rice", nameSv: "Basmatiris", nameFi: "Basmatiriisi", dietary: ["L", "G", "V"] },
        { name: "Nepalese-Style Fried Rice", nameSv: "Nepalesiskt stekt ris", nameFi: "Nepalilainen paistettu riisi", dietary: ["G"] },
        { name: "Fresh Tandoori Naan Bread", nameSv: "Färskt tandoori-naanbröd", nameFi: "Tuore tandoori-naanleipä" },
        { name: "Raita", nameSv: "Raita", nameFi: "Raita (jogurttikastike)", dietary: ["G"] },
        { name: "Mango Lassi", nameSv: "Mango Lassi", nameFi: "Mango lassi", dietary: ["G"] },
        { name: "Traditional Nepalese Chai — Masala Milk Tea", nameSv: "Traditionell nepalesisk chai — Masala-mjölkte", nameFi: "Perinteinen nepalilainen chai – maustettu maitotee", dietary: ["G"] }
      ],
      desserts: [
        { name: "Dessert of the Day — Specially Handmade with Love", nameSv: "Dagens dessert — handgjord med kärlek", nameFi: "Päivän jälkiruoka – käsin tehty rakkaudella", descriptionFi: "Nauti erityisestä, tuoreena valmistetusta kotitekoisesta jälkiruoasta, jonka keittiömme on tehnyt rakkaudella – buffet-kokemuksesi makea päätös. Ravintola Sunsari – ripaus makeutta, alusta asti itse tehty.", description: "Enjoy a special, freshly prepared homemade dessert, lovingly crafted by our kitchen to make your buffet experience even sweeter. Ravintola Sunsari — A little sweetness, made from scratch.", descriptionSv: "Njut av en speciell, nylagad hemlagad dessert, omsorgsfullt tillagad av vårt kök för att göra din bufféupplevelse ännu sötare. Restaurang Sunsari — lite sötma, gjord från grunden." }
      ]
    },
    thursday: {
      day: "Thursday · Royal Curry House",
      daySv: "Torsdag · Kungligt curryhus",
      dayFi: "Torstai · Kuninkaallinen curryhuone",
      hours: "11:00-15:00",
      mains: [
        { name: "Royal Butter Chicken", nameSv: "Kunglig smörkyckling", nameFi: "Kuninkaallinen voikana", descriptionFi: "Klassista kanaa samettisessa, kermaisessa voikastikkeessa.", chefPick: true, description: "Classic chicken in a smooth, creamy butter sauce.", descriptionSv: "Klassisk kyckling i en len, krämig buttersås.", dietary: ["L", "G"] },
        { name: "Royal Chicken Korma", nameSv: "Kunglig kycklingkorma", nameFi: "Kuninkaallinen kanakorma", descriptionFi: "Mureaa kanaa miedossa, aromaattisessa ja kermaisessa currykastikkeessa.", description: "Tender chicken in a mild, aromatic and creamy curry.", descriptionSv: "Mör kyckling i en mild, aromatisk och krämig curry.", dietary: ["L", "G"] },
        { name: "Honey Garlic Pork with Sesame", nameSv: "Honungs- och vitlöksfläsk med sesam", nameFi: "Hunaja-valkosipuliporsas ja seesami", descriptionFi: "Porsasta makeassa ja suolaisessa hunaja-valkosipuliglaseerauksessa seesamin kera.", description: "Pork coated in a sweet and savoury honey-garlic glaze with sesame.", descriptionSv: "Fläsk i en söt och smakrik honungs- och vitlöksglaze med sesam.", dietary: ["L", "G"] },
        { name: "Shahi Tofu Maharaja", nameSv: "Shahi tofu maharaja", nameFi: "Shahi-tofu maharaja", descriptionFi: "Tofua täyteläisessä, kuninkaallisessa kastikkeessa lämmittävien mausteiden kera.", description: "Tofu in a rich, royal-style sauce with warming spices.", descriptionSv: "Tofu i en fyllig, kunglig sås med värmande kryddor.", dietary: ["L", "G"] },
        { name: "Coconut Himalayan Vegetable Curry", nameSv: "Himalayansk grönsakscurry med kokos", nameFi: "Himalajan kookos-kasviscurry", descriptionFi: "Sekakasviksia haudutettuna tuoksuvassa kookoscurryssa.", description: "Mixed vegetables simmered in a fragrant coconut curry.", descriptionSv: "Blandade grönsaker som fått sjuda i en doftande kokoscurry.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Crispy Mustard Aloo", nameSv: "Krispig senapsaloo", nameFi: "Rapea sinappiperuna (aloo)", descriptionFi: "Perunaa sinapinsiementen ja perinteisten mausteiden kera.", description: "Potatoes tossed with mustard seeds and traditional spices.", descriptionSv: "Potatis blandad med senapsfrön och traditionella kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Aloo Chops", nameSv: "Aloo chops", nameFi: "Aloo chopit", descriptionFi: "Maustettuja perunapihvejä – rapeita pinnalta, pehmeitä sisältä.", description: "Seasoned potato patties, crisp on the outside and soft inside.", descriptionSv: "Kryddade potatisbiffar, krispiga på utsidan och mjuka inuti.", dietary: ["L", "G", "V"], vegan: true }
      ],
      sides: [
        { name: "Basmati Rice", nameSv: "Basmatiris", nameFi: "Basmatiriisi", dietary: ["L", "G", "V"] },
        { name: "Nepalese-Style Fried Rice", nameSv: "Nepalesiskt stekt ris", nameFi: "Nepalilainen paistettu riisi", dietary: ["G"] },
        { name: "Fresh Tandoori Naan Bread", nameSv: "Färskt tandoori naanbröd", nameFi: "Tuore tandoori-naanleipä" },
        { name: "Raita", nameSv: "Raita", nameFi: "Raita (jogurttikastike)", dietary: ["G"] },
        { name: "Mango Lassi", nameSv: "Mango lassi", nameFi: "Mango lassi", dietary: ["G"] },
        { name: "Traditional Nepalese Chai — Masala Milk Tea", nameSv: "Traditionell nepalesisk chai — masala mjölkte", nameFi: "Perinteinen nepalilainen chai – maustettu maitotee", dietary: ["G"] }
      ],
      desserts: [
        { name: "Dessert of the Day — Specially Handmade with Love", nameSv: "Dagens dessert — handgjord med kärlek", nameFi: "Päivän jälkiruoka – käsin tehty rakkaudella", descriptionFi: "Nauti erityisestä, tuoreena valmistetusta kotitekoisesta jälkiruoasta, jonka keittiömme on tehnyt rakkaudella – buffet-kokemuksesi makea päätös. Ravintola Sunsari – ripaus makeutta, alusta asti itse tehty.", description: "Enjoy a special, freshly prepared homemade dessert, lovingly crafted by our kitchen to make your buffet experience even sweeter. Ravintola Sunsari — A little sweetness, made from scratch.", descriptionSv: "Njut av en speciell, nygjord hemlagad dessert, kärleksfullt tillagad i vårt kök för att göra din bufféupplevelse ännu sötare. Restaurang Sunsari — lite sötma, gjord från grunden." }
      ]
    },
    friday: {
      day: "Friday · Himalayan BBQ & Spice",
      daySv: "Fredag · Himalayansk BBQ & kryddor",
      dayFi: "Perjantai · Himalajan BBQ & mausteet",
      hours: "11:00-15:00",
      mains: [
        { name: "Royal Butter Chicken", nameSv: "Kunglig smörkyckling", nameFi: "Kuninkaallinen voikana", descriptionFi: "Mureaa kanaa kermaisessa, miedosti maustetussa voikastikkeessa.", chefPick: true, description: "Tender chicken in a creamy, mildly spiced butter sauce.", descriptionSv: "Mör kyckling i en krämig buttersås med mild kryddning.", dietary: ["L", "G"] },
        { name: "Special Himalayan Grilled Chicken", nameSv: "Himalayansk specialgrillad kyckling", nameFi: "Himalajan erikoisgrillikana", descriptionFi: "Mehevää grillikanaa Himalajan mausteissa marinoituna.", description: "Juicy grilled chicken marinated with Himalayan spices.", descriptionSv: "Saftig grillad kyckling marinerad med himalayanska kryddor.", dietary: ["L", "G"] },
        { name: "Tandoori-Style Pork BBQ with Smoky Glaze", nameSv: "Tandooriinspirerad fläsk-BBQ med rökig glaze", nameFi: "Tandoori-tyylinen BBQ-porsas savuglaseerauksella", descriptionFi: "Grillattua porsasta täyteläisellä, savuisella BBQ-glaseerauksella.", description: "Grilled pork coated in a rich, smoky barbecue glaze.", descriptionSv: "Grillat fläsk täckt med en fyllig, rökig barbecueglaze.", dietary: ["L", "G"] },
        { name: "Colourful Golden Vegetable Jalfrezi", nameSv: "Färgstark gyllene grönsaks-jalfrezi", nameFi: "Värikäs kasvis-jalfrezi", descriptionFi: "Värikkäitä kasviksia maustetussa, maukkaassa curryssa.", description: "Colourful vegetables tossed in a spiced, flavourful curry.", descriptionSv: "Färgstarka grönsaker vända i en kryddig och smakrik curry.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Palak Tofu Curry", nameSv: "Palak tofu curry", nameFi: "Palak-tofucurry", descriptionFi: "Tofua suolaisessa pinaattikastikkeessa aromaattisten mausteiden kera.", description: "Tofu cooked in a savoury spinach sauce with aromatic spices.", descriptionSv: "Tofu tillagad i en smakrik spenatsås med aromatiska kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Crispy Mustard Potatoes", nameSv: "Krispiga senapspotatisar", nameFi: "Rapeat sinappiperunat", descriptionFi: "Kullanruskeita perunoita sinapin ja mausteiden kera.", description: "Golden potatoes seasoned with mustard and spices.", descriptionSv: "Gyllene potatisar kryddade med senap och kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Vegetable Pakora", nameSv: "Grönsaks pakora", nameFi: "Kasvispakorat", descriptionFi: "Rapeita, kevyesti maustettuja kasvisfrittereitä.", description: "Crispy, lightly spiced vegetable fritters.", descriptionSv: "Krispiga, lätt kryddade grönsaksfriteringar.", dietary: ["L", "G", "V"], vegan: true }
      ],
      sides: [
        { name: "Basmati Rice", nameSv: "Basmatiris", nameFi: "Basmatiriisi", dietary: ["L", "G", "V"] },
        { name: "Nepalese-Style Pulao Rice", nameSv: "Nepalesiskt pulao-ris", nameFi: "Nepalilainen pulao-riisi", dietary: ["G"] },
        { name: "Fresh Tandoori Naan Bread", nameSv: "Färskt tandoori naanbröd", nameFi: "Tuore tandoori-naanleipä" },
        { name: "Raita", nameSv: "Raita", nameFi: "Raita (jogurttikastike)", dietary: ["G"] },
        { name: "Mango Lassi", nameSv: "Mango lassi", nameFi: "Mango lassi", dietary: ["G"] },
        { name: "Traditional Nepalese Chai — Masala Milk Tea", nameSv: "Traditionell nepalesisk chai — masala mjölkte", nameFi: "Perinteinen nepalilainen chai – maustettu maitotee", dietary: ["G"] }
      ],
      desserts: [
        { name: "Dessert of the Day — Specially Handmade with Love", nameSv: "Dagens dessert — handgjord med kärlek", nameFi: "Päivän jälkiruoka – käsin tehty rakkaudella", descriptionFi: "Nauti erityisestä, tuoreena valmistetusta kotitekoisesta jälkiruoasta, jonka keittiömme on tehnyt rakkaudella – buffet-kokemuksesi makea päätös. Ravintola Sunsari – ripaus makeutta, alusta asti itse tehty.", description: "Enjoy a special, freshly prepared homemade dessert, lovingly crafted by our kitchen to make your buffet experience even sweeter. Ravintola Sunsari — A little sweetness, made from scratch.", descriptionSv: "Njut av en speciell, nygjord hemlagad dessert, kärleksfullt tillagad i vårt kök för att göra din bufféupplevelse ännu sötare. Restaurang Sunsari — lite sötma, gjord från grunden." }
      ]
    },
    weekend: {
      day: "Saturday · Grand Himalayan Royal Buffet",
      daySv: "Lördag · Storslagen himalayansk kunglig buffé",
      dayFi: "Lauantai · Suuri Himalajan kuninkaallinen buffet",
      hours: "12:00-16:00",
      tagline: "Our chef's finest — the best of Sunsari, served every Saturday.",
      taglineSv: "Det bästa från vår kock — det bästa av Sunsari, serverat varje lördag.",
      taglineFi: "Kokkimme parhaat – Sunsarin parhaat palat joka lauantai.",
      mains: [
        { name: "Royal Butter Chicken", nameSv: "Kunglig smörkyckling", nameFi: "Kuninkaallinen voikana", descriptionFi: "Mureaa kanaa täyteläisessä, kermaisessa voikastikkeessa.", chefPick: true, description: "Tender chicken in a rich, creamy butter sauce.", descriptionSv: "Mör kyckling i en fyllig, krämig buttersås.", dietary: ["L", "G"] },
        { name: "Sunsari Special Himalayan Chicken", nameSv: "Sunsaris speciella himalayanska kyckling", nameFi: "Sunsarin erikois-Himalajan kana", descriptionFi: "Tunnusomainen grillikanamme aromaattisissa Himalajan mausteissa marinoituna.", description: "Our signature grilled chicken, marinated with aromatic Himalayan spices.", descriptionSv: "Vår signatur-grillkyckling, marinerad med aromatiska himalayanska kryddor.", dietary: ["L", "G"] },
        { name: "Sunsari Special Pork Choila", nameSv: "Sunsaris speciella fläsk-choila", nameFi: "Sunsarin erikoisporsas-choila", descriptionFi: "Savuista, perinteisesti maustettua nepalilaista porsasta tuoreen sipulin kera.", description: "Smoky, traditionally spiced Nepalese pork served with fresh onions.", descriptionSv: "Rökigt, traditionellt kryddat nepalesiskt fläskkött serverat med färsk lök.", dietary: ["L", "G"] },
        { name: "Royal Himalayan Lamb Rogan Josh", nameSv: "Kunglig himalayansk lamm rogan josh", nameFi: "Kuninkaallinen Himalajan lammas rogan josh", descriptionFi: "Mureaa lammasta haudutettuna täyteläisessä, aromaattisessa curryssa perinteisin maustein.", description: "Tender lamb simmered in a rich, aromatic curry with traditional spices.", descriptionSv: "Mört lamm som fått sjuda i en fyllig, aromatisk curry med traditionella kryddor.", dietary: ["G"] },
        { name: "Royal Malai Kofta with Creamy Butter Sauce", nameSv: "Kunglig malai kofta i krämig smörsås", nameFi: "Kuninkaallinen malai kofta kermaisessa voikastikkeessa", descriptionFi: "Pehmeitä kasvispyöryköitä täyteläisessä, kermaisessa voikastikkeessa.", description: "Soft vegetable dumplings in a rich, creamy butter sauce.", descriptionSv: "Mjuka grönsaksdumplings i en fyllig, krämig smörsås.", dietary: ["G"] },
        { name: "Shahi Paneer Maharaja", nameSv: "Shahi paneer maharaja", nameFi: "Shahi paneer maharaja", descriptionFi: "Intialaista tuorejuustoa täyteläisessä, hienovaraisesti maustetussa kuninkaallisessa kastikkeessa.", description: "Indian cottage cheese in a rich, delicately spiced royal sauce.", descriptionSv: "Indisk färskost i en fyllig, milt kryddad kunglig sås.", dietary: ["G"] },
        { name: "Spicy Tofu Chilli", nameSv: "Kryddig tofu chilli", nameFi: "Tulinen chilitofu", descriptionFi: "Tofua chilin, valkosipulin ja voimakkaiden mausteiden kera.", description: "Tofu tossed with chilli, garlic and bold spices.", descriptionSv: "Tofu vänd i chilli, vitlök och kraftiga kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Golden Mustard Potato Chops", nameSv: "Gyllene potatiskroketter med senap", nameFi: "Kultaiset sinappiperunachopit", descriptionFi: "Rapeita perunapihvejä sinapin ja mausteiden kera.", description: "Crispy potato patties seasoned with mustard and spices.", descriptionSv: "Krispiga potatisbiffar kryddade med senap och kryddor.", dietary: ["L", "G", "V"], vegan: true },
        { name: "Vegetable Pakora", nameSv: "Grönsakspakora", nameFi: "Kasvispakorat", descriptionFi: "Kullanruskeita, rapeita kasvisfrittereitä.", description: "Golden, crunchy vegetable fritters.", descriptionSv: "Gyllene, krispiga grönsaksfritters.", dietary: ["L", "G", "V"], vegan: true }
      ],
      sides: [
        { name: "Basmati Rice", nameSv: "Basmatiris", nameFi: "Basmatiriisi", dietary: ["L", "G", "V"] },
        { name: "Vegetable Pulao", nameSv: "Grönsakspulao", nameFi: "Kasvispulao", dietary: ["G"] },
        { name: "Fresh Garlic Naan Bread", nameSv: "Färskt garlic naan", nameFi: "Tuore valkosipulinaan" },
        { name: "Raita", nameSv: "Raita", nameFi: "Raita (jogurttikastike)", dietary: ["G"] },
        { name: "Mango Lassi", nameSv: "Mango Lassi", nameFi: "Mango lassi", dietary: ["G"] },
        { name: "Traditional Nepalese Chai — Masala Milk Tea", nameSv: "Traditionell nepalesisk chai — masala mjölkte", nameFi: "Perinteinen nepalilainen chai – maustettu maitotee", dietary: ["G"] }
      ],
      desserts: [
        { name: "Dessert of the Day — Specially Handmade with Love", nameSv: "Dagens dessert — handgjord med kärlek", nameFi: "Päivän jälkiruoka – käsin tehty rakkaudella", descriptionFi: "Nauti erityisestä, tuoreena valmistetusta kotitekoisesta jälkiruoasta, jonka keittiömme on tehnyt rakkaudella – buffet-kokemuksesi makea päätös. Ravintola Sunsari – ripaus makeutta, alusta asti itse tehty.", description: "Enjoy a special, freshly prepared homemade dessert, lovingly crafted by our kitchen to make your buffet experience even sweeter. Ravintola Sunsari — A little sweetness, made from scratch.", descriptionSv: "Njut av en speciell, färskt tillagad hemlagad dessert, kärleksfullt skapad av vårt kök för att göra din bufféupplevelse ännu sötare. Restaurang Sunsari — lite sötma, gjord från grunden." }
      ]
    }
  }
};

// À la Carte Menu
export const alaCarteMenu = {
  appetizers: {
    title: "Appetizers",
    items: [
        {
          name: "Vegetable Pakora",
          description: "Fried vegetables with aromatic spices",
          price: "7,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Vegetable Samosa", 
          description: "Crispy deep fried pastries with vegetables",
          price: "7,50€",
          dietary: ["nut-free"]
        },
        {
          name: "Chicken Pakora",
          description: "Fried chicken pieces with spices",
          price: "8,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Prawn Pakora",
          description: "Fried prawns with spices",
          price: "9,00€", 
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Onion Rings",
          description: "Onion rings with chickpea flour in Nepalese spices",
          price: "6,50€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Paneer Pakora",
          description: "Deep fried fresh cheese",
          price: "9,00€",
          dietary: ["gluten-free", "nut-free"]
        }
      ]
    },
    
    soups: {
      title: "Soups",
      items: [
        {
          name: "Chicken Soup",
          description: "Herb-infused chicken soup",
          price: "8,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Vegetable Soup",
          description: "Creamy coconut vegetable soup", 
          price: "7,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Prawn Soup",
          description: "Creamy prawn soup",
          price: "9,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Mix Tharpu Soup",
          description: "Mixed soup with mushroom, chicken and prawn",
          price: "10,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        }
      ]
    },

    chicken: {
      title: "Chicken Dishes",
      subtitle: "All dishes served with basmati rice",
      items: [
        {
          name: "Butter Chicken",
          description: "Chicken in tomato cashew creamy butter sauce",
          price: "18,50€",
          dietary: ["lactose-free", "gluten-free"],
          popular: true,
          image: "https://customer-assets.emergentagent.com/job_resto-design-1/artifacts/4vxzxau8_butter%20chicken.jpg"
        },
        {
          name: "Chicken Tikka Masala",
          description: "Yogurt marinated and grilled chicken in tikka masala sauce",
          price: "18,50€",
          dietary: ["gluten-free", "nut-free"]
        },
        {
          name: "Chicken Korma",
          description: "Chicken in medium cashew curry sauce",
          price: "19,00€",
          dietary: ["lactose-free", "gluten-free"]
        },
        {
          name: "Chicken Saag",
          description: "Chicken in creamy spinach curry sauce",
          price: "18,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Tharpu Chicken",
          description: "Chicken in garlic-ginger-onion-curry sauce",
          price: "18,50€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Chicken Chilli",
          description: "Chicken in onion-paprika-chilli-soja sauce",
          price: "18,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"],
          spicy: true
        },
        {
          name: "Chicken Vindaloo",
          description: "Chicken in extremely hot vindaloo-curry sauce",
          price: "18,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"],
          spicy: "extra"
        },
        {
          name: "Chicken Tikka Grilled",
          description: "Marinated chicken breast with onion-capsicum-yogurt-tikka sauce",
          price: "19,00€",
          dietary: ["gluten-free", "nut-free"],
          image: "https://customer-assets.emergentagent.com/job_resto-design-1/artifacts/xa6i1vsk_grilled%20chicken.jpg"
        }
      ]
    },

    lamb: {
      title: "Lamb Dishes", 
      subtitle: "All dishes served with basmati rice",
      items: [
        {
          name: "Lamb Korma",
          description: "Lamb stew in curry cashew creamy sauce",
          price: "20,50€",
          dietary: ["lactose-free", "gluten-free"]
        },
        {
          name: "Tharpu Lamb",
          description: "Stew lamb in coriander ginger garlic curry sauce",
          price: "20,50€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Fighting Lamb",
          description: "Stew lamb in garlic paprika-chili-creamy sauce",
          price: "20,50€",
          dietary: ["lactose-free", "gluten-free"],
          signature: true
        },
        {
          name: "Butter Lamb",
          description: "Stew lamb in tomato-cashew-creamy-butter sauce",
          price: "20,50€",
          dietary: ["lactose-free", "gluten-free"]
        },
        {
          name: "Lamb Vindaloo",
          description: "Stew lamb in extremely hot vindaloo curry sauce",
          price: "20,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"],
          spicy: "extra"
        },
        {
          name: "Lamb Rogan",
          description: "Stew lamb in garlic-chilli-curry-tikka sauce",
          price: "20,00€",
          dietary: ["gluten-free", "nut-free"],
          image: "https://customer-assets.emergentagent.com/job_resto-design-1/artifacts/d9kzgv6i_lamb%20Rogan.jpg"
        }
      ]
    },

    vegetarian: {
      title: "Vegetarian",
      items: [
        {
          name: "Malai Kofta",
          description: "Fried vegetable and cheese balls with cashew-butter sauce",
          price: "17,50€",
          dietary: ["gluten-free"],
          vegan: "option available"
        },
        {
          name: "Palak Paneer",
          description: "Cottage cheese (tofu option) in spinach-curry sauce", 
          price: "17,50€",
          dietary: ["nut-free", "gluten-free"],
          vegan: "option available"
        },
        {
          name: "Tofu Chili",
          description: "Tofu with paprika-onion-tomato-soja-chili sauce",
          price: "17,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"],
          vegan: true,
          spicy: true
        },
        {
          name: "Vegetable Korma",
          description: "Mix vegetables and paneer in cashew nuts curry sauce",
          price: "17,50€",
          dietary: ["gluten-free"],
          vegan: "option available"
        }
      ]
    },

    sizzlers: {
      title: "Sizzlers",
      subtitle: "Served on hot plate",
      items: [
        {
          name: "Tandoor Mix Sizzler",
          description: "Yogurt marinated chicken, lamb tenderloin, king prawn, paneer with capsicum and specialty sauces",
          price: "27,00€",
          dietary: ["nut-free", "gluten-free"],
          signature: true,
          image: "https://customer-assets.emergentagent.com/job_resto-design-1/artifacts/uuuc4qa1_sizzler.jpg"
        },
        {
          name: "Special Tandoor Assortment",
          description: "Yogurt marinated chicken, lamb tenderloin, king prawn, pike-perch with capsicum in masala and cashew sauce",
          price: "50,00€",
          dietary: ["nut-free", "gluten-free"],
          subtitle: "For two persons",
          signature: true
        },
        {
          name: "Paneer Sizzler",
          description: "Cottage cheese marinated in herbs and yogurt in ginger-paprika-onion tikka-masala sauce",
          price: "21,00€",
          dietary: ["nut-free", "gluten-free"],
          vegan: "option available"
        }
      ]
    },

    seafood: {
      title: "Seafood",
      items: [
        {
          name: "Garlic Fish",
          description: "Pike-perch in ginger coriander garlic curry sauce",
          price: "19,50€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Butter Fish", 
          description: "Pike-perch in tomato creamy cashew butter sauce",
          price: "19,50€",
          dietary: ["lactose-free", "gluten-free"]
        },
        {
          name: "Garlic Prawn",
          description: "King prawns with onion, ginger in tomato curry sauce",
          price: "22,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        },
        {
          name: "Butter Prawn",
          description: "King prawns in tomato-cashew-butter sauce",
          price: "22,00€",
          dietary: ["lactose-free", "gluten-free"]
        },
        {
          name: "Chilli Prawn",
          description: "King prawns with fresh tomato, onion, capsicum in chili-soja sauce",
          price: "22,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"],
          spicy: true
        }
      ]
    },

    desserts: {
      title: "Desserts",
      items: [
        {
          name: "Kulfi King",
          description: "Popular Nepalese ice cream with mango, pistachio and cashew, cardamom and saffran with caramel sauce",
          price: "8,00€",
          dietary: ["gluten-free"],
          signature: true
        },
        {
          name: "Tharpu Chef Special",
          description: "Fried banana with honey and rum in vanilla ice-cream with whipped cream",
          price: "8,00€",
          dietary: ["lactose-free", "gluten-free", "nut-free"],
          signature: true
        },
        {
          name: "Mango Lassi",
          description: "Nepalese mango-yogurt smoothie",
          price: "4,00€",
          dietary: ["gluten-free"]
        },
        {
          name: "Mixed Ice Cream",
          description: "Two ice cream balls (chocolate and vanilla) with caramel or chocolate dressing",
          price: "6,50€",
          dietary: ["lactose-free", "gluten-free", "nut-free"]
        }
      ]
    },
    kids: {
      title: "Kids Menu",
      subtitle: "All kids dishes 10,00€ – Perfect for little ones!",
      items: [
        {
          name: "Kids Butter Chicken & Rice",
          description: "Mild creamy butter chicken with steamed basmati rice",
          price: "10,00€",
          dietary: ["gluten-free", "nut-free"]
        },
        {
          name: "Kids Tandoori Chicken & Naan",
          description: "Tender grilled chicken pieces with soft naan bread",
          price: "10,00€",
          dietary: ["nut-free"]
        },
        {
          name: "Kids Chicken Tikka & Rice",
          description: "Mild spiced chicken tikka with fluffy basmati rice",
          price: "10,00€",
          dietary: ["gluten-free", "nut-free"]
        },
        {
          name: "Kids Veggie Curry & Rice",
          description: "Mild mixed vegetable curry with steamed rice",
          price: "10,00€",
          dietary: ["vegetarian", "gluten-free", "nut-free"]
        },
        {
          name: "Kids Paneer & Naan",
          description: "Mild creamy paneer with soft naan bread",
          price: "10,00€",
          dietary: ["vegetarian", "nut-free"]
        },
        {
          name: "Kids Naan & Butter",
          description: "Freshly baked naan with butter on the side",
          price: "10,00€",
          dietary: ["vegetarian"]
        }
      ]
    }
};

// Neapolitan Pizza Menu
export const pizzaMenu = {
  leRosse: {
    title: "Le Rosse",
    subtitle: "Klassiset pizzat tomaattipohjalla",
    items: [
      { name: "1. Margherita (V)", description: "San Marzano -tomaatti, fior di latte, tuore basilika", price: "14,00€", dietary: ["vegetarian"] },
      { name: "2. Diavola Rosso", description: "Tulinen salami, gorgonzola, San Marzano -tomaatti, fior di latte", price: "17,50€" },
      { name: "3. Mediterranean Breeze", description: "San Marzano -tomaatti, fior di latte, buffalomozzarella, kirsikkatomaatti", price: "16,50€" },
      { name: "4. Tropicale Felice", description: "San Marzano -tomaatti, mozzarella, kinkku, ananas", price: "18,00€" },
      { name: "5. Pepperoni Serenade", description: "San Marzano -tomaatti, fior di latte, pepperoni, Grana Padano, ranch-kastike", price: "16,50€" },
      { name: "6. Puttanesca Elegante", description: "San Marzano -tomaatti, fior di latte, tonnikala, anjovis, kapris, oliivi", price: "17,00€" },
      { name: "7. Rustic Country", description: "San Marzano -tomaatti, fior di latte, porsaanmakkara, munakoiso, burrata", price: "18,50€" }
    ]
  },
  leBianche: {
    title: "Le Bianche",
    subtitle: "Gourmet-pizzat kermapohjalla",
    items: [
      { name: "8. Truffle Thyme Symphony (V)", description: "Ricotta-tryffelikreemi, Parmigiano, sienet, timjami, saksanpähkinä", price: "16,50€", dietary: ["vegetarian"] },
      { name: "9. Sweet Cheesus", description: "Mozzarella, ricotta, pecorino, ruskistettu voi, pancetta", price: "17,00€" },
      { name: "10. Uh-Mami!", description: "Fior di latte, pancetta, artisokka, villisienet, salvia, pecorino-kastike", price: "17,00€" },
      { name: "11. Lumberjack Supreme", description: "Fior di latte, prosciutto, sieni, taleggio, savustettu burrata", price: "18,50€" },
      { name: "12. Rosemary's Bacon", description: "Mozzarella, bataatti, rosmariini, savustettu pekoni, vuohenjuusto", price: "18,00€" }
    ]
  },
  chickenCreations: {
    title: "Chicken Creations",
    subtitle: "Kanan ystäville",
    items: [
      { name: "13. Pollo Verde Elegante", description: "Grillattu kana, paahdettu paprika, basilika-pesto, fior di latte", price: "16,90€" },
      { name: "14. Rustic Chicken & Mushroom", description: "San Marzano -tomaatti, kananpojan koipireisi, metsäsienet, parmesaani", price: "16,90€" }
    ]
  },
  vegan: {
    title: "Vegaaniset Herkut",
    subtitle: "Vegan delights",
    items: [
      { name: "15. Vegan Margherita (V)", description: "San Marzano -tomaatti, cashew-kerma, basilika, kuivatut tomaatit", price: "15,00€", dietary: ["vegetarian"] },
      { name: "16. Garden Harvest (V)", description: "San Marzano -tomaatti, cashew-kerma, vegaaninen juusto, grillatut kasvikset", price: "16,00€", dietary: ["vegetarian"] },
      { name: "17. Mediterranean Vegan Delight (V)", description: "San Marzano -tomaatti, cashew-kerma, artisokka, oliivit, paprika", price: "16,50€", dietary: ["vegetarian"] }
    ]
  },
  specials: {
    title: "Specials",
    subtitle: "Pizza of the Month & Nordic Special",
    items: [
      { name: "Napoli Nord Piccante'", description: "Fior di latte mozzarella, San Marzano -tomaatti, tulinen salami, 'nduja, gorgonzola, pancetta, parmesaani, tuore basilika", price: "17,50€", isSpecial: true },
      { name: "18. Revontuli Lammas", description: "Fior di latte, pitkään haudutettu lammas, juurekset, puolukka, rosmariini – Pohjoismainen Erikoisuus", price: "18,50€", isSpecial: true }
    ]
  }
};